export default __webpack_public_path__ + "static/media/bangla_lang.d8213cec.png";